<template>
	<section>
		<container textButton="voltar" :pathName="path" :pathIcone="true">
			<div class="filters">
				<div class="titulo"> Tipos de Questão: </div>
				<div class="linha">
					<Multiselect placeholder="Selecione o tipo de questão" v-model="tipoQuestaoSelecionado" track-by="id" label="descricao" :options="filters.tiposQuestao" class="select tipo" />
					<div class="exportar" @click="exportar">
						Exportar
					</div>
				</div>
			</div>

			<div v-if="computedQuestions.length === 0" class="objectNotFound">
					Não existem questões do tipo selecionado associadas ao objeto :)
			</div>

			<div id="questoes-list">
				<div class="container-questao-colapse" v-for="questao in computedQuestions" :key="questao.id">
					<label>
						<input class="switch" type="radio" :id="questao.id" name="questao" :ref="'quest'"/>
						<div class="collapse-header">
							<span>Questão {{  getTipoById(questao.idTipoQuestao) }}</span>
							<!-- <span v-if="questao.codigo" class="codigo">
								<copiar :text="questao.codigo"></copiar> -->
							<!-- </span> -->
							<span class="spin-down">
								<i class="fas fa-chevron-down"></i>
							</span>
						</div>
						<div class="collapse bottom-border-radius">
							<div class="content">

								<div class="dificuldade">
									<div class="historico">
										<button :disabled="!questao.historico" @click="historyId = questao.id">
											<i class="fas fa-history"></i>
											HISTÓRICO
										</button>
									</div>
								</div>

								<box-title-text :title="'Enunciado'" :text="questao.enunciado"></box-title-text>

								<click-option-load-content v-if="questao.alternativas && questao.alternativas.length" :id="questao.id" :labelText="'ALTERNATIVA'" :list="questao.alternativas" :propPath="['valor']"></click-option-load-content>

								<spootlight-info-bar v-if="questao.alternativas && questao.alternativas.length"
									:labelText="'Alternativa correta:'"
									:labelColor="'#ffffff'"
									:barColor="'#1a2738'"
									:itemDefaultColor="'#f3f7fc'"
									:spootlightColor="'#eff536'"
									:list="questao.alternativas"
									:spootIndex="questao.alternativas.findIndex(a => a.correta)">
								</spootlight-info-bar>

								<box-title-text v-if="questao.gabarito" :title="'Gabarito comentado'" :text="questao.gabarito.texto"></box-title-text>

								<box-title-text :title="'Feedback Positivo'" :text="questao.feedbackPositivo"></box-title-text>
								<box-title-text :title="'Feedback Negativo'" :text="questao.feedbackNegativo"></box-title-text>
							</div>
						</div>
					</label>
				</div>
			</div>
		</container>

		<new-modal v-if="historyId" @close="historyId = undefined" id="historico-modal">
				<div class="header" slot="header">
					<span>
						<i class="fas fa-history"></i>
						HISTÓRICO
					</span>
				</div>
				<div slot="body">
					<historico :question="historyId"></historico>
				</div>
		</new-modal>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import container from '@/components/shared/Container'
import boxTitleText from '@/components/shared/BoxTitleText'
import newModal from '@/components/shared/NewModal'
import clickOptionLoadContent from '@/components/shared/ClickOptionLoadContent'
// import copiar from '@/components/shared/Copiar'
import spootlightInfoBar from '@/components/shared/SpootlightInfoBar'
import historico from '@/components/views/questoes/Historico'
import { questoes } from '@/services/questoes'
import Multiselect from 'vue-multiselect'

export default {
	name: 'objetoQuestoes',
	components: { container, /* copiar, */ boxTitleText, spootlightInfoBar, clickOptionLoadContent, newModal, historico, Multiselect },
	data () {
		return {
			path: '',
			historyId: undefined,
			filters: {
				tiposQuestao: []
			},
			temaId: this.$route.params.id,
			tipoQuestaoSelecionado: { id: 'todos', descricao: 'Todos' }
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = from.path
		})
	},
	async created () {
		const tipoQuestao = await questoes.findTipos()
		this.filters.tiposQuestao = tipoQuestao.data
		this.filters.tiposQuestao.push({ id: 'todos', descricao: 'Todos' })
	},
	mounted () {
		if (this.$refs.quest) this.$refs.quest[0].checked = true
	},
	computed: {
		...mapState({
			questions: state => state.questions.list,
			computedQuestions (state) {
				if (this.tipoQuestaoSelecionado.id !== 'todos') {
					const questoes = state.questions.list.filter(questao => questao.idTipoQuestao === this.tipoQuestaoSelecionado.id)
					return questoes
				} else {
					return state.questions.list
				}
			}
		})
	},
	methods: {
		getTipoById (id) {
			const tipo = this.filters.tiposQuestao.find(tipo => tipo.id === id)
			return tipo !== undefined ? ` - ${tipo.descricao}` : ''
		},
		async exportar () {
			const params = {
				tema: this.temaId,
				tipoQuestao: this.tipoQuestaoSelecionado.id !== 'todos' ? this.tipoQuestaoSelecionado.id : ''
			}
			const retorno = await questoes.processReport(params)
			window.open(retorno.data.arquivo)
		}
	}
}
</script>

<style lang="scss" scoped>
	.container-questao-colapse {
		label {
			.collapse-header {
				border-radius: 10px 10px 0px 0px;
				background-color: #4f5c6b;
				padding: 10px 15px;
				margin-top: 10px;
				display: inline-flex;
				align-items: center;
				gap: 25px;
				width: 100%;
				height: 60px;
				color: #FFF;
				span {
					&:first-of-type {
						font-size: $font-size-large;
						font-weight: $font-weight-default-bolder;
						cursor: pointer;
					}
					&:last-of-type {
						margin-left: auto;
						cursor: pointer;
					}
					&.codigo {
						background-color: #3b4550;
						display: inline-flex;
						align-items: center;
						height: 30px;
						padding: 0px 15px;
						border-radius: 25px;
						font-size: $font-size;
					}
				}
			}
			.switch{
				display: none;
			}
			.switch:checked {
				& ~ .collapse {
					max-height: 800px;
				}
				& ~ .collapse-header{
					.spin-down {
						i{
							display: none;
						}
					}
				}
			}
			.switch:not(:checked) {
				& ~ .collapse-header{
					border-radius: 10px;
					cursor: pointer;
					&:hover {
						.spin-down {
							i {
								transition: visibility 0s, opacity 0.3s linear;
								visibility: visible;
								opacity: 1;
							}
						}
					}
				}
			}
			.collapse {
				background-color: white;
				border-radius: 0px 0px 10px 10px;
				color: $font-color;
				max-height: 0px;
				overflow: hidden;
				transition: max-height 0.9s ease-out;

				.content {
					position: relative;
					max-height: 80vh;
					overflow: auto;
					padding: 10px;
					border: 1px solid #F1F1F3;

					.dificuldade {
						width: 100%;
						border-radius: 4px;
						display: inline-flex;
						gap: 15px;

						.historico {
							position: absolute;
							top: 18px;
							right: 12px;

							button {
								background-color: $main-color;
								font-weight: $font-weight-buttons;
								border: none;
								cursor: pointer;
								color: white;
								padding: 10px;
								border-radius: 4px;
								&:hover {
									background-color: #0f1924;
								}
								&:disabled {
									background-color: #9e9e9e;
									cursor: default;
								}
							}
						}
					}
					.alternativas {
						margin-top: 20px;
						.items {
							display: inline-flex;
							gap: 15px;
							align-items: center;
							user-select: none;
							div {
								label {
									.radio-item {
										display: none;
										&:checked {
											& ~ span {
												background-color: #4f5c6b;
												color: white
											}
										}
									}
									span {
										background-color: $inputs-color;
										font-size: $font-size;
										font-weight: $font-weight-default-bolder;
										padding: 5px 15px;
										border-radius: 7px;
										cursor: pointer;
										&:hover{
											background-color: $inputs-color-hover;
										}
									}
								}
							}
						}
						.texto {
							padding: 5px;
							margin-top: 10px;
							border: solid 1px $inputs-color;
							max-height: 90px;
							overflow-y: auto;
						}
					}
				}
			}
		}
	}

	.filters {
		color: $font-color;
		font-size: $font-size;
		.linha {
			display: flex;
			.multiselect {
				// background-color: $main-color;
				border: 2px solid $default-color;
				width: 300px;
			}
			.exportar {
				cursor: pointer;
				color: $default-color;
				padding: 10px;
				margin-left: 15px;
				background-color: $main-color;
			}
		}
		.titulo {
			font: Condensed Bold 14px/26px Roboto;
			display: block;
			align-items: center;
			height: 32px;

			.aviso {
				margin-left: 15px;
				color: rgb(134, 18, 18);
				font-size: 12px;
			}
		}
	}

	.objectNotFound {
		margin-top: 50px;
		color: #000;
		text-align: center;
	}

	#historico-modal {
		color: black;
		.header{
			width: 100%;
			display: inline-flex;
			color: $main-color;
			font-weight: $font-weight-default-bolder;
			font-size: $font-size-large;
			.close {
				margin-left: auto;
			}
		}
	}
</style>

<style lang="scss">
	#questoes-list .collapse .dificuldade + .box {
		margin-top: -20px;
	}

	#questoes-list .collapse .box img {
		max-width: 100%;
	}
</style>
